import { AcademicLevel, Campus, ChoixDocumentation, CityDocumentation, Consentement, CountryDocumentation, Email, FirstName, LastName, MobilePhone, PostalCode, Section, Specialites, StreetDocumentation } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...ChoixDocumentation,
  ...Consentement,
  formations: Yup.array().min(1, 'Vous devez choisir au minimum une formation'),
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...CityDocumentation,
    ...CountryDocumentation,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhone,
    ...PostalCode,
    ...StreetDocumentation,
    ...Section
  }),
  ...Specialites
})

export default schema
